import { lazy, type ComponentType } from "react";

// Wraps React.lazy with one auto-retry on transient chunk-load failures.
// On final failure, error propagates to the route's errorElement.
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      const msg = (err as { message?: string })?.message ?? "";
      const isChunkErr =
        msg.includes("dynamically imported module") ||
        msg.includes("Importing a module script failed") ||
        msg.includes("ChunkLoadError");
      if (!isChunkErr) throw err;
      await new Promise((r) => setTimeout(r, 600));
      return factory();
    }
  });
}
